import { objectUtils } from '@festina-life/core'
import { useRef } from 'react'

export const useStableObjectKey = <T extends WeakKey>() =>
  useRef(objectUtils.createReactKeyGetterFromObjectIdentity<T>()).current
